import { FC } from 'react';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';
import Table from 'modules/_shared/Table';

import HistoryMovementsViewExpandedTableHeader from './HistoryMovementsViewExpandedTableHeader';
import HistoryMovementsViewExpandedTableBody from './HistoryMovementsViewExpandedTableBody';

import { useHistoryMovementsView } from '../context/HistoryMovementsViewContext';

const HistoryMovementsViewExpandedTable: FC = () => {
  const { data, actions } = useHistoryMovementsView();

  const showPagination = data.totalHistoryMovements > 5;

  const tableContent = (
    <>
      <HistoryMovementsViewExpandedTableHeader />
      <HistoryMovementsViewExpandedTableBody />
    </>
  );

  return (
    <>
      <Table content={tableContent} scrollHorizontal />

      {showPagination && (
        <TablePagination
          totalRows={data.totalHistoryMovements}
          defaultRowsPerPage={data.rowsPerPage}
          onChangePage={actions.handleChangePage}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
        />
      )}
    </>
  );
};

export default HistoryMovementsViewExpandedTable;
